import { object, string, TypeOf } from "zod";

export const newsLetterFormValidation = object({
  name: string().min(1, "Nombre obligatorio"),
  surname: string().min(1, "Apellido obligatorio"),
  email: string().email("Email inválido"),
});

export type INewsletterForm = TypeOf<typeof newsLetterFormValidation>;